<br>
<div class="box">

  <h3 class="kozep">
    Stats
  </h3>

  <p>Ez itt az stats page és itt fogjuk elmagyarázni, hogy működik a statisztika, hogyan számolunk és linkeljük a publikus adatokat.</p>
  <p>Lorem ipsum dolor sit amet, sed ne mazim elaboraret, vix no verear latine, an feugait delectus definitiones vim. Cum ad probo mundi oratio. Mea aliquip facilisis scripserit ne, liber patrioque te eam, eam dicam debitis ex. Te vocibus postulant nec. Eos nibh iuvaret contentiones at. Sea admodum indoctum eu.</p>
  <p>Eam iriure dolorem in, eos eirmod feugiat te. Legere feugiat corpora per et, epicuri disputationi ius et. Cu sit eripuit docendi pertinax. Te novum melius mea, nec lorem falli omittam cu, erant gubergren ne sed. Eum at quaeque sapientem, facete suavitate forensibus cum in. Adipisci maiestatis et mei, te has putent mentitum voluptua.</p>

</div>


<style>

.kozep {
  text-align: center;
}

div.box {
  border: 1px solid #DDD;
  border-radius: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
  background-color: #f6f6f6;
}

</style>
